<template>
	<div>
		<div v-if="$store.getters.isPc" class="main-w">
			<div class="row cb header">
				<div class="breadcrumb">
					<span @click="$router.push('/')">首页</span>
					<span>></span>
					<span>正文</span>
				</div>
				<div class="row cc right">
					<span class="date">{{ date }}</span>
					<span class="browse">浏览次数:2019次</span>
				</div>
			</div>
			<div class="col form-view cc">
				<h2>招生机构查询</h2>
				<div class="input-view">
					<el-form :model="ruleForm" :rules="rules" ref="formData">
						<el-form-item prop="name">
							<input type="text" v-show="false" />
							<el-input placeholder="请输入机构全称" v-model="ruleForm.name" @keyup.enter.native="handleQuery">
								<div slot="append"><el-button type="primary" class="query-btn" :loading="queryLoading" @click="handleQuery">查询</el-button></div>
							</el-input>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="desc">
				<p>为促进健康科普研究中心职业技能培证书训项目在各地有序推广和不断提升品质，形成良好口碑，依据项目合作协议约定的基本原则制定本管理细则。</p>
				<p>（一）招生宣传</p>
				<p>1.招生简章标题及内容应准确清晰，不夸大，无误导。</p>
				<p>2.不得出现政府职能安排、转移、授权等误导性描述；不得出现本项目与职业资格、鉴定、认证等挂钩的相关表述。</p>
				<p>3.使用标准版的合格证书样本，证书性质描述准确（详见招生简章模板）。</p>
				<p>
					4.对接机构如果发展合作机构招生，应提前备案。对接机构负责审查合作机构的招生文案，保证符合项目的宣传规范。合作招生机构若出现宣传问题，由相应的对接机构承担责任。
				</p>
				<p>（二）招生咨询接待</p>
				<p>1.要求招生人员如实介绍本项目宗旨、课程设置、课时、师资、培训过程、日常考勤、习题作业考评等内容。</p>
				<p>2. 机构可介绍自己的经验、规模、教学成果和质量，但不得过度承诺。招生人员不得向学员做不用上课直接考试、包过或保证考试通过率等违规承诺。</p>
				<p>3.机构应在合作协议约定价格内招生，应以信誉、服务和教学质量来吸引学员，与其他机构公平竞争。不得低价竞争，不得诋毁其他对接机构。</p>
				<p>4. 如实介绍证书效力，不得以"健康科普研究中心"等名义对学员做任何合作协议之外的承诺。</p>
				<p>5.如发生学员因前期咨询不清晰，造成误解形成投诉，机构应承担责任，并积极解决学员诉求，尽量达成一致，避免对机构及培训项目形成负面影响。</p>
				<p>6. 机构应对所属招生人员和合作机构的招生人员做认真的岗前培训及考核，因招生人员在招生中做虚假承诺或宣传，造成影响和投诉的，由对接机构承担相应责任。</p>
				<p>项目合作联系人：杨老师 联系电话：17610028051</p>
				<div class="col end">
					<p>健康科普研究中心</p>
					<p>2021年4月29日</p>
				</div>
			</div>
		</div>
		<div class="col mobile-main" onselectstart="return false;" v-else>
			<div class="logo"></div>
			<div class="col form-view">
				<div class="title">招生机构查询</div>
				<el-form :model="ruleForm" :rules="rules" ref="formData">
					<input type="text" v-show="false" />
					<el-form-item prop="name"><el-input placeholder="请输入机构全称" v-model="ruleForm.name" @keyup.enter.native="handleQuery"></el-input></el-form-item>
					<el-button type="primary" class="query-btn" round @click="handleQuery">查询</el-button>
				</el-form>
			</div>
			<div class="bottom"></div>
		</div>
	</div>
</template>

<script>
import { Message } from 'element-ui';
import { Toast } from 'vant';
export default {
	data() {
		return {
			ruleForm: { name: '' },
			rules: {
				name: [{ required: true, message: '请输入机构全称', trigger: 'blur' }]
			},
			queryLoading: false,
			date: ''
		};
	},
	components: {},
	beforeCreate() {},
	created() {
		var date = new Date();
		this.date = date.toLocaleDateString();
	},
	methods: {
		handleQuery() {
			this.$refs['formData'].validate(valid => {
				if (valid) {
					this.queryLoading = true;
					this.service1('cert/serarchMech', this.ruleForm)
						.then(res => {
							if (res.code === 0) {
								if (this.$store.getters.isPc) {
									Message.error(res.msg);
								} else {
									Toast(res.msg);
								}
							} else {
								this.$router.push({
									path: '/partner/result/' + this.ruleForm.name
								});
							}
							this.$refs['formData'].clearValidate();
						})
						.finally(() => {
							this.queryLoading = false;
						});
				}
			});
		}
	}
};
</script>
<style lang="less" scoped>
/deep/ .el-button {
	transition: 0s;
}
.mobile-main {
	align-items: center;
	height: 100vh;
	background-color: #007475;
	overflow: hidden;
	.logo {
		margin-top: 1.493333rem;
		width: 9.2rem;
		height: 5.44rem;
		background: url(../../assets/partner/logo1.png) no-repeat center;
		background-size: cover;
	}
	.bottom {
		margin-top: auto;
		width: 100%;
		height: 2.533333rem;
		background: url(../../assets/partner/bottom.png) repeat-x top;
		background-size: cover;
	}
	.form-view {
		align-items: center;
		margin-top: 0.933333rem;
		width: 92%;
		background-color: #ffffff;
		border-radius: 0.266666rem;
		padding: 0.8rem 0.266666rem;
		box-sizing: border-box;
		.title {
			color: #007475;
			font-size: 0.533333rem;
		}
		/deep/ .el-input__inner {
			border-top: none;
			border-left: none;
			border-right: none;
			padding-left: 0.266666rem;
			border-radius: 0 !important;
			margin-top: 0.8rem;
			font-size: 0.426666rem;
			height: 1.066666rem;
			line-height: 1.066666rem;
		}
		/deep/ .el-form-item__error {
			font-size: 0.32rem;
		}
		.query-btn {
			width: 7.413333rem;
			background-color: #007475;
			border: none;
			height: 1.066666rem;
			border-radius: 0.533333rem;
			font-size: 0.48rem;
			margin-top: 0.8rem;
		}
	}
}

.main-w {
	font-size: 18px;
	.header {
		height: 70px;
		.breadcrumb {
			color: rgba(0, 116, 117, 1);
			span {
				cursor: Pointer;
				margin-right: 8px;
			}
		}
		.right {
			.date {
				line-height: 18px;
				color: #666666;
			}
			.browse {
				line-height: 18px;
				margin-left: 30px;
				color: #333333;
			}
		}
	}
	/deep/ .el-input__inner {
		border-radius: 0 !important;
	}
	.form-view {
		width: 100%;
		height: 278px;
		background: rgba(209, 209, 209, 0.2);
		h2 {
			color: #007475;
			margin-bottom: 30px;
		}
		.input-view {
			width: 660px;

			.query-btn {
				width: 108px;
				background-color: #007475;
				color: #ffffff;
				border-radius: 0;
			}
		}
	}
	.desc {
		p {
			margin: 24px 0;
		}
		.end {
			font-weight: bold;
			align-items: flex-end;
			p {
				margin: 10px 0 !important;
			}
		}
	}
}
</style>
